import { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Input,
  Heading,
  HStack,
  FormControl,
} from "@chakra-ui/react";
import CodesetSelect from "./CodesetSelect";
import CodesetSelectWithFilters from "./CodesetSelectWithFilters";
import { HiOutlinePlus, HiOutlineTrash } from "react-icons/hi";

const DateTimesEditor = ({
    dateTimes = [], 
    onChange,
    filter = null,
    size = "md", // ✅ Chakra size prop: xs, sm, md, lg
}) => {
  const [localDateTimes, setLocalDateTimes] = useState(dateTimes);

  useEffect(() => {
    setLocalDateTimes(dateTimes);
  }, [dateTimes]);

  const handleChange = (index, field, value) => {
    const updated = [...localDateTimes];
    updated[index][field] = value;
    setLocalDateTimes(updated);
    onChange(updated);
  };

  const handleAdd = () => {
    const newItem = {
      type: "",
      format: "",
      timeZoneCode: "",
      value: "",
      description: "",
    };
    const updated = [...localDateTimes, newItem];
    setLocalDateTimes(updated);
    onChange(updated);
  };

  const handleDelete = (index) => {
    const updated = [...localDateTimes];
    updated.splice(index, 1);
    setLocalDateTimes(updated);
    onChange(updated);
  };

  return (
    <Box borderWidth="1px" borderRadius="md" p={4} borderColor="gray.500">
      <HStack mb={3} justifyContent="flex-start">
        <Heading size={size}>Date Times</Heading>
        <IconButton icon={<HiOutlinePlus />} size={size} onClick={handleAdd} />
      </HStack>

      <Table variant="simple" size={size}>
        <Thead>
          <Tr>
            <Th fontSize={size}>Type</Th>
            <Th fontSize={size}>Format</Th>
            <Th fontSize={size}>Time Zone</Th>
            <Th fontSize={size}>Date</Th>
            <Th fontSize={size}>Description</Th>
            <Th fontSize={size}></Th>
          </Tr>
        </Thead>
        <Tbody>
          {localDateTimes.map((dt, idx) => (
            <Tr key={idx}>
              <Td>
                <CodesetSelect
                    codesetCode="T04"
                    // If filter is provided, pass it to CodesetSelect
                    filter={filter ? filter : null}
                    value={dt.type ? { code: dt.type, description: "" } : null}
                    onChange={(val) => handleChange(idx, "type", val.code)}
                    size={size}
                    height="32px"
                />
              </Td>
              <Td>
                <Input
                  value={dt.format}
                  onChange={(e) => handleChange(idx, "format", e.target.value)}
                  size={size}
                  height="32px"
                  placeholder="Format"
                />
              </Td>
              <Td>
                <CodesetSelect
                    codesetCode="B39"
                    value={dt.timeZoneCode ? { code: dt.timeZoneCode, description: "" } : null}
                    onChange={(val) => handleChange(idx, "timeZoneCode", val.code)}
                    size={size}
                    height="32px"
                />
              </Td>
              <Td>
                <Input
                  value={dt.value}
                  onChange={(e) => handleChange(idx, "value", e.target.value)}
                  size={size}
                  height="32px"
                />
              </Td>
              <Td>
                <Input
                  value={dt.description}
                  onChange={(e) => handleChange(idx, "description", e.target.value)}
                  size={size}
                  height="32px"
                />
              </Td>
              <Td>
                <IconButton
                  icon={<HiOutlineTrash />}
                  size={size}
                  aria-label="Delete"
                  onClick={() => handleDelete(idx)}
                />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default DateTimesEditor;
